import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import {
  displayProfileModal,
  setProfileModalPage,
  setTransportationMall,
  setSurveyModalStatus,
} from '../../../modules/profile/actions/creators'

import MainView from '../components/MainView/MainView'

const mapStateToProps = reduxState => {
  const { auth, profile, recovery } = reduxState

  const { accessToken } = auth

  const {
    primaryInfo,
    showProfileModal,
    profileModalPage,
    surveyModalStatus,
    surveyData,
  } = profile

  const { recoveryStep } = recovery

  return {
    recoveryStep,
    accessToken,
    primaryInfo,
    showProfileModal,
    profileModalPage,
    surveyModalStatus,
    surveyData,
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      displayProfileModal,
      setProfileModalPage,
      setTransportationMall,
      setSurveyModalStatus,
      push,
    },
    dispatch,
  )

const ConnectedMainView = connect(mapStateToProps, mapDispatchToProps)(MainView)

export default ConnectedMainView
